import api from "../../utils/apiUser";

const normalizeSearchText = (text = "") => {
  return String(text)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]/g, "");
};

export const getProductosPublic = async (params = {}) => {
  const {
    limit = 20,
    offset = 0,
    search = "",
    category = null,
    brand = null,
  } = params;

  const cleanSearch = String(search ?? "").trim();

  const res = await api.get("/api/public/productos", {
    params: {
      limit,
      offset,
      search: cleanSearch,
      searchNormalized: normalizeSearchText(cleanSearch),
      category: category ?? "",
      brand: brand ?? "",
    },
  });

  return res.data;
};

export const getProductoPublicById = async (id) => {
  const res = await api.get(`/api/public/productos/${id}`);
  return res.data;
};

export const getProductosRelacionados = async (id) => {
  const res = await api.get(`/api/public/productos/${id}/relacionados`);
  return res.data;
};